import React, { useState, memo } from "react";

export function s3ToHttps(s3Url) {
  if (!s3Url) return null;
  // s3://horse-race-prediction/silks/101285.png → https://horse-race-prediction.s3.eu-north-1.amazonaws.com/silks/101285.png
  const match = s3Url.match(/^s3:\/\/([^/]+)\/(.+)$/);
  if (!match) return s3Url; // already an http(s) url or unknown format
  return `https://${match[1]}.s3.eu-north-1.amazonaws.com/${match[2]}`;
}

function SilkImage({ url }) {
  const [error, setError] = useState(false);
  const src = s3ToHttps(url);

  if (!src || error) {
    return (
      <div
        className="md:w-9 md:h-9 w-8 h-8 rounded-lg bg-[var(--color-bg)] border border-[var(--color-border)] flex items-center justify-center md:text-sm text-xs text-[var(--color-text-muted)] shrink-0"
      >
        🐴
      </div>
    );
  }

  return (
    <img
      src={src}
      alt="silk"
      onError={() => setError(true)}
      className="md:w-9 md:h-9 w-8 h-8 rounded-lg object-contain bg-[var(--color-bg)] border border-[var(--color-border)] shrink-0"
    />
  );
}

export default memo(SilkImage);
